var path = '/_common/directives/ifastValidator/ifastValidator.tpl.html';
var html = " <form data-kendo-validator=ifastValidator.validation.validator data-k-options=ifastValidator.validation.options data-k-on-validate=ifastValidator.validation.onValidate(kendoEvent) novalidate autocomplete=off> <div data-ng-show=\"!ifastValidator.validation.validator.validate() && ifastValidator.validationMessageVisible\" class=\"alert alert-danger ng-hide\" role=alert> <ul class=invalid-list> <li ng-repeat=\"input in ifastValidator.inputs\"><span class=k-invalid-msg data-for={{input}}></span></li> </ul> </div> <div ng-transclude></div> </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastValidator/ifastValidator.tpl.html
// module id = 785
// module chunks = 0 2